import React from "react";

export default function InputInstagramUrl({ errors, register }) {
  return (
    <input
      className={`form-control ${errors.instagram_url && "is-invalid"}`}
      type="text"
      placeholder="https://instagram.com/usuario"
      name="instagram_url"
      {...register("instagram_url", {
        pattern: {
          value: /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._-]+\/?$/,
          message:
            "La URL debe comenzar con https://instagram.com/ y contener un usuario",
        },
      })}
    />
  );
}
